import { render, staticRenderFns } from "./OurStorySlider.vue?vue&type=template&id=5b579593&scoped=true&"
import script from "./OurStorySlider.vue?vue&type=script&lang=js&"
export * from "./OurStorySlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b579593",
  null
  
)

export default component.exports